(function(){
  if(customElements.get('cr-simple-name'))return;
  class SimpleName extends HTMLElement {
    #controller;
    connectedCallback(){
      this.#controller?.abort();this.#controller=new AbortController();
      const form=this.closest('form'),input=this.querySelector('input');
      if(!form||!input)return;
      const sync=()=>{const id=form.querySelector('[name=id]')?.value;const needed=this.dataset.variantIds.split(',').includes(id);this.hidden=!needed;input.disabled=!needed;input.required=needed;};
      const target=this.closest('.shopify-section,dialog');
      for(const name of ['variant:update','variant:selected'])target?.addEventListener(name,()=>queueMicrotask(sync),{signal:this.#controller.signal});
      input.addEventListener('input',()=>input.setCustomValidity(''),{signal:this.#controller.signal});
      form.addEventListener('submit',event=>{if(!input.disabled&&!input.value.trim()){event.preventDefault();event.stopImmediatePropagation();input.setCustomValidity(this.dataset.error);input.reportValidity();}},{capture:true,signal:this.#controller.signal});
      sync();
    }
    disconnectedCallback(){this.#controller?.abort();}
  }
  customElements.define('cr-simple-name',SimpleName);
})();
